<template>
  <div class="bdo-radio">

    <span
       :key="index"
       :class="{'active': item.value === value}"
       v-for="(item, index) in labelArray"
       @click="onRadioClick(item)">
      {{item.label}}
    </span>


    <!--    <span @click="leftClick">{{leftLabel}}</span>-->
    <!--    <span @click="rightClick">{{rightLabel}}</span>-->
  </div>
</template>

<script>
  export default {
    name: "BdoRadio",

    props: {
      value: {
        type: [String, Number],
        default: ""
      },

      //选中的按钮值
      activeLabel: {
        type: [String, Number],
        default: ""
      },

      // 按钮数组文案
      labelArray: {
        type: Array,
        default: function () {
          return []
        }
      },

      //模式:  true则必选,  false为 非必选
      mode: {
        type: Boolean,
        default: true
      }
    },

    data() {
     return {
       activeText: ""
     }
    },

    watch: {
      value(newValue) {
        this.activeText = newValue
      },

      activeText(newValue) {
        this.$emit("input", newValue)
      }
    },

    methods: {
      onRadioClick(item) {

        if(!this.mode){
          if(this.activeText === item.value) {
            this.activeText = ""
            this.$emit("on-click", this.activeText)
            return
          }
        }
        if(this.activeText === item.value) return
        this.activeText = item.value
        this.$emit("on-click", this.activeText)
      },

    }
  }
</script>

<style lang="scss" scoped>
  .bdo-radio {
    /*display: flex;*/
    /*justify-content: space-between;*/
    /*align-items: center;*/
    /*width: 500px;*/

    span {
      display: inline-block;
      width: 182px;
      font-family: Nunito-Bold;
      /*flex: 1;*/
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #E5F5FF;
      border-radius: 8px;
      font-size: 14px;
      color: #2C2C2C;
      letter-spacing: 0;
      cursor: pointer;
      margin-right: 20px;

      & + span {
        /*margin-right: 20px;*/
        margin-left: 10px;
      }

      &.active {
        background: #FFBB00;
        color: #FFFFFF;
      }
    }

    .left_radio {

    }
  }
</style>